// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 342 ? "ea88be26" : chunkId) + "." + {"51":"e7ffc39fa9a5de71","342":"2dae61655338be7f"}[chunkId] + ".js";
};